"use client";

import type { TranslatedLocale } from "../../../const/i18n";
import type { PricingCopy } from "../../../dictionaries/en/pricing";
import { pricing as frPricing } from "../../../dictionaries/fr/pricing";
import PricingContent from "../../(marketing)/pricing/pricing-content";

// This page's text recalculates on the client, with the viewer's price arm, so its
// dictionary can't come from the server as props. Only this route loads it.
const PRICING: Record<TranslatedLocale, PricingCopy> = { fr: frPricing };

export default function LocalizedPricing({ lang }: { lang: TranslatedLocale }) {
  return <PricingContent copy={PRICING[lang]} />;
}
